package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.InventoryItem
import fr.manyverse.app.domain.repository.InventoryRepository
import fr.manyverse.app.domain.validation.InventoryItemValidator

class UpdateInventoryItemQuantityUseCase(
    private val inventoryRepository: InventoryRepository
) {
    suspend operator fun invoke(itemId: String, newQuantity: Int): Result<InventoryItem> {
        InventoryItemValidator.validateQuantity(newQuantity).onFailure {
            return Result.failure(it)
        }

        return inventoryRepository.updateQuantity(itemId, newQuantity)
    }
}
